import { action, makeAutoObservable } from 'mobx';
import { Collection } from '@common/merch';

export class StoreStore {
  public collections: Collection[];
  public currentCollection: Collection | null;
  public isLoading: boolean;
  public productBanners: Map<string, { text: string; color: string }>;
  public playersOnline: number;
  public discordOnline: number;
  public isDiscordLoading: boolean;
  public isMinecraftLoading: boolean;

  constructor() {
    this.collections = [];
    this.currentCollection = null;
    this.isLoading = false;
    this.productBanners = new Map();
    this.playersOnline = 0;
    this.discordOnline = 0;
    this.isDiscordLoading = false;
    this.isMinecraftLoading = false;
    makeAutoObservable(this);
  }

  @action
  public updateCollections(collections: Collection[]): void {
    // Hide empty collections so they don't appear as tabs or show a "no products" message.
    this.collections = collections.filter((collection) => (collection.products?.length ?? 0) > 0);
  }

  @action
  public setCurrentCollection(collection: Collection | null): void {
    this.currentCollection = collection;
  }

  @action
  public setLoading(isLoading: boolean): void {
    this.isLoading = isLoading;
  }

  @action
  public setBanners(banners: Map<string, { text: string; color: string }>): void {
    this.productBanners = banners;
  }

  public getBanner(productId: string): { text: string; color: string } | undefined {
    return this.productBanners.get(productId);
  }

  @action
  public setPlayersOnline(count: number): void {
    this.playersOnline = count;
  }

  @action
  public setDiscordOnline(count: number): void {
    this.discordOnline = count;
  }

  @action
  public setDiscordLoading(isLoading: boolean): void {
    this.isDiscordLoading = isLoading;
  }

  @action
  public setMinecraftLoading(isLoading: boolean): void {
    this.isMinecraftLoading = isLoading;
  }

  @action
  public resetAll(): void {
    this.collections = [];
    this.currentCollection = null;
    this.isLoading = false;
    this.productBanners = new Map();
    this.playersOnline = 0;
    this.discordOnline = 0;
    this.isDiscordLoading = false;
    this.isMinecraftLoading = false;
  }
}
